import React, { Component } from "react";
import {
    Table
} from "react-bootstrap";
import moment from "moment";

export default class View extends Component {
    render () {
        let {
            selectedData
        } = this.props;

        let GET_DATA = (key) => {
            let value = "";

            if (selectedData) {
                if (
                    key === "memberId" &&
                    selectedData.attributes &&
                    selectedData.attributes["MMID"]
                ) {
                    value = selectedData.attributes["MMID"]
                } else if (
                    key === "cardType" &&
                    selectedData.attributes &&
                    selectedData.attributes["Card Type"]
                ) {
                    value = selectedData.attributes["Card Type"]
                } else if (
                    key === "name" &&
                    selectedData.attributes &&
                    selectedData.attributes["First Name"]
                ) {
                    value = selectedData.attributes["First Name"]
                } else if (
                    key === "dob" &&
                    selectedData.attributes &&
                    selectedData.attributes["DOB"]
                ) {
                    value = selectedData.attributes["DOB"]
                } else if (
                    key === "dad" &&
                    selectedData.attributes &&
                    selectedData.attributes["Date Added"]
                ) {
                    value = selectedData.attributes["Date Added"]
                } else if (
                    (
                        key === "createdAt" ||
                        key === "updatedAt"
                    ) &&
                    selectedData[key]
                ) {
                    value = moment(selectedData[key]).format("MMM DD, YYYY hh:mm A");
                }
            }

            return value;
        };

        let data = [
            {
                label: "MEMBER ID",
                value: GET_DATA("memberId")
            },
            {
                label: "CARD TYPE",
                value: GET_DATA("cardType")
            },
            {
                label: "NAME",
                value: GET_DATA("name")
            },
            {
                label: "DOB",
                value: GET_DATA("dob")
            },
            {
                label: "DAD",
                value: GET_DATA("dad")
            },
            {
                label: "CREATED AT",
                value: GET_DATA("createdAt")
            },
            {
                label: "UPDATED AT",
                value: GET_DATA("updatedAt")
            }
        ];

        return (
            <div>
                <Table striped bordered condensed hover responsive>
                    <tbody>
                        {data.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <b>{item.label}</b>
                                    </td>
                                    <td>
                                        {item.value}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/Kumulos/FormContainer/View.js